import appConfig from "../app.json";

const apiUrls = {
  stage: "https://imvi-api-dev-li3wqfyhtq-nw.a.run.app",
  prod: "https://imvi-api-prod-li3wqfyhtq-nw.a.run.app"
};

// Determine the current environment from the appConfig
const environment = appConfig.environment || "stage";

// Set the Cloud API URL based on the current environment
const Cloud_API_URL = apiUrls[environment];

export { Cloud_API_URL };
